import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import MediaQuery from 'react-responsive'

import imgBannerDesk from '@loyal_images/banners/Banner_latam_pass_778x150.png'
import imgBannerMob from '@loyal_images/banners/Banner_latam_pass_420x150.png'

const mileageHeaderIupp = ({
  vendorId
}) => (
  <div className='row'>
    <div>
      <div
        className='bg-viagens-new radius-top row align-items-center'
        data-mileage={vendorId}
      >
        <MediaQuery maxDeviceWidth={475}>
          <a href='https://www.pontosmultiplus.com.br/latampass/iupp-pontos-extras' target='_blank'>
            <img src={imgBannerMob} title='Ganhe até 100% de pontos Extras, transfira seus pontos do iupp para o LATAM Pass e aproveite 3 anos de validade.' />
          </a>
        </MediaQuery>
        <MediaQuery minDeviceWidth={476}>
          <a href='https://www.pontosmultiplus.com.br/latampass/iupp-pontos-extras' target='_blank'>
            <img src={imgBannerDesk} title='Ganhe até 100% de pontos Extras, transfira seus pontos do iupp para o LATAM Pass e aproveite 3 anos de validade.' />
          </a>
        </MediaQuery>
      </div>
    </div>
  </div>
)

mileageHeaderIupp.propTypes = {
  vendorId: PropTypes.string
}
const mapStateToProps = ({ oidc }) => {
  return ({ campaignId: oidc && oidc.user && oidc.user.profile['custom:campaign_id'] })
}
export default connect(mapStateToProps)(mileageHeaderIupp)



// WEBPACK FOOTER //
// ./src/features/MileageRescue/mileageHeaderIupp.js